export function getURLHashParams(keys) {
  const params = new URLSearchParams(window.location.hash.replace('#', '?'))

  return (keys || []).reduce((p, c) => {
    const value = params.get(c)

    return { ...p, [c]: value === 'true' ? true : value }
  }, {})
}

export function setURLHash(name, value) {
  const params = new URLSearchParams(window.location.hash.replace('#', '?'))

  if (params.has(name)) {
    params.delete(name)
  }
  params.append(name, value)

  window.history.pushState({}, '', '#' + params)
}

export function removeURLHash(name) {
  const params = new URLSearchParams(window.location.hash.replace('#', '?'))

  if (params.has(name)) {
    params.delete(name)
  }

  window.history.pushState({}, '', '#' + params)
}
